export enum TimeSeriesEntityTypeConstants {
  STRATEGY = 'STRATEGY',
  BENCHMARK = 'BENCHMARK',
  PURE_FACTOR = 'PURE_FACTOR',
  PURE_FACTOR_SIGNAL = 'PURE_FACTOR_SIGNAL',
  PRIVATE_STRATEGY = 'PRIVATE_STRATEGY',
  FUND = 'FUND',
  PUBLIC_THEMATIC = 'PUBLIC_THEMATIC',
  THEMATIC = 'THEMATIC',
  THEMATIC_BENCHMARK = 'THEMATIC_BENCHMARK',
  /**
   * Core & HSBC-specific: Should have data on core and hsbc only.
   */
  SIGNAL = 'SIGNAL',
  MARKET_DATA = 'MARKET_DATA',
  STOCK = 'STOCK',
  CASH = 'CASH',
  PUBLIC_FUND = 'PUBLIC_FUND',
  PRIVATE_FUND = 'PRIVATE_FUND',
  STRUCTURED_PRODUCT = 'STRUCTURED_PRODUCT',
}

// Access rights logic depending on strategy type. This logic should be kept in sync with API.
// List of datafeed types which do not have other checking other than data type checking
export const PUBLIC_TYPES = [
  TimeSeriesEntityTypeConstants.PURE_FACTOR,
  TimeSeriesEntityTypeConstants.PURE_FACTOR_SIGNAL,
  TimeSeriesEntityTypeConstants.BENCHMARK,
  TimeSeriesEntityTypeConstants.THEMATIC_BENCHMARK,
  TimeSeriesEntityTypeConstants.CASH,
  TimeSeriesEntityTypeConstants.STOCK,
  TimeSeriesEntityTypeConstants.FUND,
  TimeSeriesEntityTypeConstants.STRUCTURED_PRODUCT,
  TimeSeriesEntityTypeConstants.MARKET_DATA,
  TimeSeriesEntityTypeConstants.SIGNAL,
];

// Access rights logic depending on strategy type. This logic should be kept in sync with API.
// List of datafeed types which are checked against provider or fundProvider
export const TYPES_BY_PROVIDER_ID = [
  TimeSeriesEntityTypeConstants.STRATEGY,
  TimeSeriesEntityTypeConstants.PUBLIC_THEMATIC,
  TimeSeriesEntityTypeConstants.PUBLIC_FUND,
];

// Access rights logic depending on strategy type. This logic should be kept in sync with API.
// List of datafeed types which are checked against teamId
export const TYPES_BY_TEAM_ID = [
  TimeSeriesEntityTypeConstants.PRIVATE_STRATEGY,
  TimeSeriesEntityTypeConstants.THEMATIC,
  TimeSeriesEntityTypeConstants.PRIVATE_FUND,
];
